"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerContainer = exports.ErrorsContainer = exports.ResultContainer = exports.DeleteButtonContainer = exports.CaseContainer = exports.ButtonsContainer = exports.CasesContainer = exports.InputContainer = exports.Root = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Root = styled_components_1.default.div `
  display: flex;
  position: relative;
  flex-wrap: wrap;
  padding: 24px;
`;
exports.InputContainer = styled_components_1.default.div `
  padding-bottom: 16px;
`;
exports.CasesContainer = styled_components_1.default.div `
  display: flex;
`;
exports.ButtonsContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  padding: 24px 0px;
  button {
    margin-right: 12px;
  }
`;
exports.CaseContainer = styled_components_1.default.div `
  position: relative;
`;
exports.DeleteButtonContainer = styled_components_1.default.div `
  position: absolute;
  left: 96px;
  bottom: -35px;
  cursor: pointer;
`;
exports.ResultContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding-bottom: 20px;
`;
exports.ErrorsContainer = styled_components_1.default.div `
  padding: 0px 0px 8px 16px;
  max-height: 90px;
  overflow: auto;
`;
exports.SpinnerContainer = styled_components_1.default.div `
  position: absolute;
  top: 300px;
  left: 620px;
  width: 100px;
`;
//# sourceMappingURL=elements.js.map